import { render, staticRenderFns } from "./first-access.vue?vue&type=template&id=7f0bb2f4&scoped=true&lang=pug&"
import script from "./first-access.vue?vue&type=script&lang=ts&"
export * from "./first-access.vue?vue&type=script&lang=ts&"
import style0 from "./first-access.vue?vue&type=style&index=0&id=7f0bb2f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0bb2f4",
  null
  
)

export default component.exports